export const SEARCH_PARAM_NAME = "search"
export const SEARCH_BAR_DEFAULT_MAX_WIDTH = "700px"
